import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "message-input"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormPC = _resolveComponent("FormPC")!
  const _component_FormMobile = _resolveComponent("FormMobile")!

  return ($setup.isPC)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FormPC, {
          payload: $setup.forwardPayload,
          onSendMessage: $setup.handleSendForm
        }, null, 8, ["payload", "onSendMessage"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_FormMobile, {
          payload: $setup.forwardPayload,
          onSendMessage: $setup.handleSendForm,
          onShowFormPopup: $setup.handleShowFormPopup
        }, null, 8, ["payload", "onSendMessage", "onShowFormPopup"])
      ]))
}